module.exports = __webpack_public_path__ + "img/mastery-banner-m.e033114.webp";